import React from 'react';
import PropTypes from 'prop-types';
import FilterSelectBox from './formComponents/FilterSelectBox';
import Translate from './Translate';
import translator from '../translations/drupalTranslator';
import VoucherEntryContainer from '../containers/VoucherEntryContainer';

class PaymentSelect extends React.Component {
  constructor(props) {
    super(props);

    this.getPaymentOptions = this.getPaymentOptions.bind(this);
    this.inputOnChange = this.inputOnChange.bind(this);
    this.getSelectedIdForPaymentMethod = this.getSelectedIdForPaymentMethod.bind(this);
  }

  getPaymentOptions() {
    return this.props.payment.paymentOptions.map(option => ({
      text: parseFloat(option.calculatedFee.amount) === 0 ?
        option.creditCardName :
        `${option.creditCardName} + ${option.calculatedFee.amount} ${option.calculatedFee.currencyCode}`,
      value: option.creditCardExternalId,
    }));
  }

  getSelectedIdForPaymentMethod() {
    return this.props.payment.paymentOptionSelected;
  }

  inputOnChange(name, value) {
    if (this.props.validate) {
      this.props.validate(value);
    }
    return this.props.selectPaymentOption(value);
  }

  render() {
    const selectClassName = ['filter-select'];

    if (this.props.errors && this.props.errors.method) {
      /**
       * Using PascalCase `Select` since react-select does not provide a
       * simple way to change the default className.
       */
      selectClassName.push('Select--error');
    }

    return (
      <div className="pay-option">
        <div>
          <Translate
            className="form-label"
            component="label"
            content="Choose your payment method. You will pay in the next step."
            htmlFor="form-label"
            onClick={() => this._select && this._select.focus()}
          />
          <FilterSelectBox
            className={selectClassName.join(' ')}
            name="paymentMethod"
            onChange={this.inputOnChange}
            options={this.getPaymentOptions()}
            placeholder={translator.translate('Select payment method')}
            reference={c => this._select = c}
            searchable={false}
            value={this.getSelectedIdForPaymentMethod()}
          />
          {this.props.voucher}
        </div>
      </div>
    );
  }
}

PaymentSelect.propTypes = {
  errors: PropTypes.shape({}),
  payment: PropTypes.shape({}).isRequired,
  rates: PropTypes.shape([]).isRequired,
  selectPaymentOption: PropTypes.func.isRequired,
  validate: PropTypes.func,
  voucher: PropTypes.instanceOf(VoucherEntryContainer),
};

export default PaymentSelect;
